import { DateTime } from "luxon"
import { MessageTagOption } from "./components/MessageTagAutoComplete"
import { UserType } from "../../../login/loginTypes"

export type Message = Readonly<{
    id: number
    title: string
    publishTime: string
    editDetails?: {
        update?: {
            canUpdate: boolean
            until: string
        }
        delete?: {
            canDelete: boolean
            until: string
        }
    }
    body: string
}>

export type MessageTagValue =
    | "INFO"
    | "IMPORTANT"
    | "OFFER"
    | "MENU_CHANGE"
    | "EVENT"
    | "REMINDER"
    | "FEEDBACK"
    | "NEWS"
    | "HEALTH"
    | "SOCIAL"

export type MessageItem = Readonly<{
    title: string
    body: string
    publishTime: string | null
    channels?: MessageAdditionalDataChannelsType[]
    tag?: {
        key: MessageTagValue
        displayName: string
    }
}>

export type MessageDetails = MessageAdditionalData &
    Readonly<{
        title: string
        body: string
        publishTime: string | null
        editDetails: {
            update: {
                canUpdate: boolean
                until: string
            }
            delete: {
                canDelete: boolean
                until: string
            }
        }
    }>

export type CreateEditMessageFormValues = Readonly<{
    title: string
    body: string
    publishTime: DateTime | null
    channels?: MessageAdditionalDataChannelsType[]
    tag?: MessageTagOption | null
}>

export enum MessageAdditionalDataRecipientsType {
    USER_TYPES = "USER_TYPES",
    MERCHANT_CUSTOMERS = "MERCHANT_CUSTOMERS",
}

export enum MessageAdditionalDataChannelsType {
    IN_APP_CARD = "IN_APP_CARD",
    IN_APP = "IN_APP",
    PUSH = "PUSH",
    SMS = "SMS",
    EMAIL = "EMAIL",
}

export type MessageAdditionalData = Readonly<{
    sender: {
        type: UserType
        merchant: {
            id: number
        }
        user: {
            id: number
        }
    }
    recipients: {
        type: MessageAdditionalDataRecipientsType
        userTypes?: UserType[]
    }[]
}>
